import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Mirador } from 'src/app/models/mirador';

@Component({
  selector: 'app-mirador-item',
  templateUrl: './mirador-item.component.html',
  styleUrls: [
    './styles/user-profile.page.scss',
    './styles/user-profile.shell.scss',
  ], 
})
export class MiradorItemComponent implements OnInit {
  @Input() mirador: Mirador;
  @Output() onMiradorClick: EventEmitter<Mirador> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  getBackUrl(){
    return `url("${this.mirador.getUrlCover()}")`;
 }

  onMiradorClicked(){
    this.onMiradorClick.emit(this.mirador);
  }

}
